import { render } from "./CreateEditProfileModal.vue?vue&type=template&id=27127034"
import script from "./CreateEditProfileModal.vue?vue&type=script&lang=js"
export * from "./CreateEditProfileModal.vue?vue&type=script&lang=js"

import exportComponent from "C:\\wamp64\\www\\projetos\\ethos-reports\\front-end\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__